import React from "react";
import { passwordRules } from "utils/validators";

export default function PasswordStrength({ password }) {
  if (!password) return null;

  return (
    <ul className="mb-3 mt-1 space-y-1 rounded-xl border border-gray-100 bg-gray-50 px-4 py-3 dark:border-white/10 dark:bg-navy-800">
      {passwordRules.map(({ label, test }) => {
        const passed = test(password);
        return (
          <li key={label} className={`flex items-center gap-2 text-xs font-medium transition-colors ${passed ? "text-green-500" : "text-gray-400"}`}>
            {passed ? (
              <svg className="h-3.5 w-3.5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            ) : (
              <svg className="h-3.5 w-3.5 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <circle cx="10" cy="10" r="3" />
              </svg>
            )}
            {label}
          </li>
        );
      })}
    </ul>
  );
}
